import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainLayouts from "../layouts/MainLayouts";
import { lazy, Suspense } from "react";
import Loader from "../components/Loader/Loader";
import RouteTracker from "../RouteTracker";
// import Contact from "../pages/Contact/Contact";
// import Home from "../pages/Home/Home";
// import About from "../pages/About/About";
// import CategoryPage from "../pages/CategoryPage/CategoryPage";
// import DetailPage from "../pages/DetailPage/DetailPage";

const Home = lazy(() => import("../pages/Home/Home"));
const Contact = lazy(() => import("../pages/Contact/Contact"));
const About = lazy(() => import("../pages/About/About"));
const Management = lazy(() => import("../pages/Management/Management"));
const CategoryPage = lazy(() => import("../pages/CategoryPage/CategoryPage"));
const DetailPage = lazy(() => import("../pages/DetailPage/DetailPage"));


const AppRouter = () => {
  return (
    <div>
      <BrowserRouter>
       <RouteTracker />
        <Suspense fallback={<Loader />}>
    
      <Routes>

        <Route element={<MainLayouts />}>

          <Route path="/" element={<Home />} />
           <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
           <Route path="/management" element={<Management />} />
          <Route path="/category/:id" element={<CategoryPage />} />
           <Route path="/category/:id/:detailId" element={<DetailPage />} />
         

        </Route>

        {/* <Route path="*" element={<NotFound />} /> */}

      </Routes>
        </Suspense>
    </BrowserRouter>
    </div>
  );
}

export default AppRouter


// const Home = lazy(() => import("./pages/Home/Home"));
// const CategoryPage = lazy(() => import("./pages/CategoryPage/CategoryPage"));
// const DetailPage = lazy(() => import("./pages/DetailPage/DetailPage"));

// const AppRouter = () => {
//   return (
//     <BrowserRouter>
//       <Suspense fallback={<LogoLoader />}>
//         <Routes>
//           <Route element={<Layout />}>
//             <Route path="/" element={<Home />} />
//             <Route path="/category/:id" element={<CategoryPage />} />
//             <Route path="/category/:id/:detailId" element={<DetailPage />} />
//           </Route>
//         </Routes>
//       </Suspense>
//     </BrowserRouter>